/** In-memory cache for one session (same pattern as Lovable NewFacility). */
const viesCache = new Map();

/**
 * EU Commission VIES REST API (browser; public endpoint).
 * @param {string} ms — two-letter member state code, e.g. "DK"
 * @param {string} vat — VAT number without country prefix
 * @returns {Promise<object>}
 */
export async function fetchViesVat(ms, vat) {
  const key = `${String(ms || "").toUpperCase()}:${String(vat || "").trim()}`;
  if (viesCache.has(key)) return viesCache.get(key);
  const url = `https://ec.europa.eu/taxation_customs/vies/rest-api/ms/${encodeURIComponent(
    String(ms || "").toUpperCase()
  )}/vat/${encodeURIComponent(String(vat || "").trim())}`;
  const res = await fetch(url);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error("vies_http");
  viesCache.set(key, data);
  return data;
}
